module.exports = __webpack_public_path__ + "img/maintenance.0a98c7a6.png";